export default {
  getList: {
    method: 'post',
    url: '/p/vehicle/remooc/list'
  },
  getById: {
    method: 'get',
    url: '/p/vehicle/remooc/ID'
  },
  add: {
    method: 'post',
    url: '/p/vehicle/remooc'
  },
  delete: {
    method: 'delete',
    url: '/p/vehicle/remooc'
  },
  archive: {
    method: 'delete',
    url: '/p/vehicle/remooc/archive'
  },
  restore: {
    method: 'put',
    url: '/p/vehicle/remooc/restore'
  },
  edit: {
    method: 'put',
    url: '/p/vehicle/remooc/id'
  },
  find: {
    method: 'get',
    url: '/p/vehicle/remooc/find?key=KEY'
  },
  getDocuments: {
    method: 'post',
    url: '/p/vehicle/remooc-document/file/ID'
  },
  uploadDocument: {
    method: 'POST',
    url: '/p/vehicle/remooc-document/upload'
  },
  updateDocument: {
    method: 'PUT',
    url: '/p/vehicle/remooc-document/file/ID'
  },
  archiveDocument: {
    method: 'delete',
    url: '/p/vehicle/remooc-document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: '/p/vehicle/remooc-document/restore'
  }
}
